<template>
  <div>
    <va-card-content style="padding-bottom:0;">
      <va-tabs v-model="tabValue" style="width: 100%; min-width: 250px;">
        <template #tabs>
          <va-tab>
            自定义头像
          </va-tab>
          <va-tab>
            热门头像推荐
          </va-tab>
        </template>
      </va-tabs>
    </va-card-content>

    <va-card-content style="height: 400px; overflow-y: scroll;">
      <!-- 自定义头像上传 -->
      <div style="padding:20px;" v-if="tabValue == 1">
        <div>
          <vxe-button status="primary" @click="insertEvent(false)">选择文件</vxe-button>
          <span class="photo-dec">支持jpg、jpeg、gif、png、bmp格式的图片</span>
        </div>
        <div style="padding-top:20px;">
          <img :src="$store.state.profilePicture" alt="" style="width:200px;height:200px;">
        </div>
      </div>

      <!-- 热门头像推荐 -->
      <div v-else class="flex x12 md12 xs12 row">
        <div
          v-for="(item, index) in photoList"
          :key="index"
          class="flex x2 xs2 md2 hot-portrait"
          @click="amend(item)"
        >
          <img
            :src="item.FilePath"
            alt=""
            :style="{'outline': saveSrc.FileName === item.FileName ? '2px solid #f00' : 'none'}"
          >
        </div>
      </div>
    </va-card-content>

    <va-card-content>
      <vxe-button
        v-if="tabValue != 1"
        @click="amendHeadPortrait"
        class="msg-submit"
        status="primary"
        content="保存"
      ></vxe-button>
    </va-card-content>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue';
import { VXETable } from 'vxe-table';
import Qs from 'qs';

export default defineComponent({
  data() {
    return {
      uploadFileUrl: null,
      oneFile: null,
      oneFileName: null,
      photoList: [],
      tabValue: ref(1), // 默认是自定义头像
      saveSrc: {}       // 存储选中的头像信息
    };
  },
  created() {
    this.getUserPhoto();
  },
  methods: {
    amendHeadPortrait() {
      if (!this.saveSrc.FileName) {
        VXETable.modal.message({ content: '请上传图片！', status: 'warning' });
        return;
      }
      const params = {
        UserID: this.$store.state.userID,
        FileName: this.saveSrc.FileName
      };
      this.$api.formsAPI.updateUserPortraitByDF(Qs.stringify(params))
        .then(res => {
          if (!res.data.Success) {
            VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
            return;
          }
          VXETable.modal.message({ content: '修改头像成功！', status: 'success' });
          this.$store.commit('updateUserInfoProfilePicture', this.saveSrc.FilePath);
          this.$emit('update', true);
        })
        .catch(error => console.log(error));
    },

    // 获取头像文件列表
    getUserPhoto() {
      this.$api.formsAPI.getDefaultPortrait()
        .then(res => {
          if (!res.data.Success) {
            VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
            return;
          }
          this.photoList = res.data.Data;

          // 判断当前头像是否在列表中，如果有则高亮
          const defaultPicture = this.photoList.find(item =>
            item.FilePath === this.$store.state.profilePicture
          );
          if (defaultPicture) {
            this.saveSrc = defaultPicture;
          }
        })
        .catch(error => console.log(error));
    },

    // 选择热门头像
    amend(item) {
      if (item) {
        this.saveSrc = item;
        console.log('选择了头像:', item);
      }
    },

    // 选择本地文件上传
    async insertEvent() {
      const { files } = await VXETable.readFile(false);
      Array.from(files).forEach(file => {
        this.oneFileName = file.name;
        this.oneFile = file;
        this.updateUserPortrait(file);
      });
    },

    // 上传头像
    updateUserPortrait(fileParam) {
      const fData = new FormData();
      fData.append('uid', this.$store.state.userID);
      fData.append('file', fileParam);
      this.$api.systemManageAPI.updateUserPortrait(fData)
        .then(res => {
          if (!res.data.Success) {
            VXETable.modal.message({ content: res.data.Message, status: 'error' });
            return;
          }
          this.uploadFileUrl = res.data.Data;
          VXETable.modal.message({ content: "头像修改成功", status: 'success' });
          this.$store.commit('updateUserInfoProfilePicture', res.data.Data);
        })
        .catch(error => console.log(error));
    }
  }
});
</script>

<style scoped lang="scss">
.msg-submit {
  border-radius: unset;
  margin: 10px 0px 0px auto;
  display: block;
}
.photo-dec {
  font-size: 12px;
  color: #a1a1a1;
  vertical-align: middle;
  margin-left: 10px;
}
.hot-portrait img {
  width: 70px;
  height: 70px;
  display: block;
  margin: 0 auto;
}
.hot-portrait img[style*='2px solid #f00'] {
  outline: 2px solid #f00;
}
</style>
